import Page from 'assets/components/page/Page';
import ThemePageList from 'assets/components/page/themes/Theme.Page.List';
import { getLocales } from 'assets/locales/Locale';
import { DataProvider } from 'assets/providers/data/DataProvider';
import { financeHomeRoute, HttpStatus } from 'config/Api.Config';
import usePostingAccount, { PostingAccountAction } from './Finance.PostingAccount.Hooks';
import ErrorPage from 'assets/templates/errorPage/ErrorPage';
import ThemePaginationRounded from 'assets/components/pagination/themes/Theme.Pagination.Rounded';
import Pagination from 'assets/components/pagination/Pagination';
import Button from 'assets/components/button/Button';
import Icon from 'assets/components/icon/Icon';
import { isDesktop, isMobile } from 'react-device-detect';
import ThemeButtonFloating from 'assets/components/button/themes/Theme.Button.Floating';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import FinancePostingAccountList from './sections/Finance.PostingAccount.List';
import FinancePostingAccountFilters from './sections/Finance.PostingAccount.Filters';
import FinancePostingAccountEdit from './sections/Finance.PostingAccount.Edit';
import FinancePostingAccountDelete from './sections/Finance.PostingAccount.Delete';
import Box from 'assets/components/box/Box';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';

export const financePostingAccountIndexRoute = financeHomeRoute + '/posting-account/:action?/:id?';
export default function FinancePostingAccountIndex() {
  const { lang } = getLocales();
  const postingAccountHook = usePostingAccount();

  if (!postingAccountHook.canView) return <ErrorPage status={HttpStatus.unauthorized} />;
  return (
    <>
      <DataProvider
        data={postingAccountHook}
        render={({ listApi, views, pageRouter, permissions }) => (
          <Page
            class={ThemePageList}
            isLoading={listApi.isExecuting}
            header={
              <>
                <h2 style={{ marginRight: 'auto' }} children={lang.postingAccounts} />
                <Box class={ThemeWrapperStack}>
                  {isMobile && <FinancePostingAccountFilters />}
                  <Button
                    class={isMobile ? ThemeButtonFloating : ThemeButtonCircle}
                    active
                    media={<Icon class="fas-plus" />}
                    render={!isMobile && lang.addNew}
                    onClick={pageRouter.updateParams}
                    disabled={!permissions.CREATE_LEDGERACCOUNT}
                    data={{ action: PostingAccountAction.EDIT, id: undefined }}
                  />
                </Box>
              </>
            }
            subHeader={isDesktop && <FinancePostingAccountFilters />}
            render={
              <>
                {views.edit && <FinancePostingAccountEdit />}
                {views.delete && <FinancePostingAccountDelete />}
                <FinancePostingAccountList />
              </>
            }
            footer={
              <Pagination
                class={ThemePaginationRounded}
                count={listApi.payload?.count}
                offset={listApi.body?.offset}
                limit={listApi.body?.limit}
                onLimitChange={(limit) => listApi.execute((body) => ({ ...body, limit, offset: 0 }))}
                onOffsetChange={(offset) => listApi.execute((body) => ({ ...body, offset }))}
              />
            }
          />
        )}
      />
    </>
  );
}
